import { CreateOrderDto } from '../dto/create-order.dto';
import { OrderItemType, OrderStatus, PaymentStatus, PaymentMethod } from '../enums/order-item-type.enum';

/**
 * Example: Order with both Product and Package items
 */
export const exampleOrderWithProductAndPackage: CreateOrderDto = {
  customerId: '507f1f77bcf86cd799439011',
  items: [
    // Regular Product Item
    {
      itemType: OrderItemType.PRODUCT,
      itemId: '507f1f77bcf86cd799439012',
      quantity: 2,
      price: 29.99,
      color: 'red',
      size: 'large',
      selectedVariants: [
        { variant: 'color', value: { en: 'red', ar: 'الأحمر' } },
        { variant: 'size', value: { en: 'large', ar: 'كبير' } }
      ]
    },
    // Package Item
    {
      itemType: OrderItemType.PACKAGE,
      itemId: '507f1f77bcf86cd799439013',
      quantity: 1,
      price: 99.99,
      discountPrice: 79.99,
      packageItems: [
        {
          productId: '507f1f77bcf86cd799439014',
          quantity: 1,
          selectedVariants: [
            { variant: 'color', value: { en: 'blue', ar: 'الأزرق' } , _id: 'color' , image: null},
            { variant: 'size', value: { en: 'medium', ar: 'متوسط' } , _id: 'size' , image: null }
          ]
        },
        {
          productId: '507f1f77bcf86cd799439015',
          quantity: 2,
          selectedVariants: [
            { variant: 'color', value: 'white' },
            { variant: 'size', value: 'small' }
          ]
        }
      ]
    }
  ],
  totalPrice: 139.97, // (2 * 29.99) + 79.99
  status: OrderStatus.PENDING,
  createdAt: new Date().toISOString(),
  paymentInfo: {
    paymentStatus: PaymentStatus.PENDING,
    paymentMethod: PaymentMethod.CASH,
    cashPayment: 150.00,
    notes: 'Cash payment to be collected on delivery'
  }
};

/**
 * Example: Order with only Product items
 */
export const exampleOrderWithProductsOnly: CreateOrderDto = {
  customerId: '507f1f77bcf86cd799439011',
  items: [
    {
      itemType: OrderItemType.PRODUCT,
      itemId: '507f1f77bcf86cd799439016',
      quantity: 1,
      price: 49.99,
      color: 'black',
      size: 'xl',
      selectedVariants: [
        { variant: 'color', value: 'black' },
        { variant: 'size', value: 'xl' }
      ]
    },
    {
      itemType: OrderItemType.PRODUCT,
      itemId: '507f1f77bcf86cd799439017',
      quantity: 3,
      price: 19.99,
      color: 'green',
      size: 'medium',
      selectedVariants: [
        { variant: 'color', value: 'green' },
        { variant: 'size', value: 'medium' }
      ]
    }
  ],
  totalPrice: 109.96, // 49.99 + (3 * 19.99)
  status: OrderStatus.PENDING,
  paymentInfo: {
    paymentStatus: PaymentStatus.PAID,
    paymentMethod: PaymentMethod.CREDIT_CARD,
    transactionId: 'txn_1234567890',
    gatewayReference: 'stripe_pi_1234567890',
    paidAt: new Date().toISOString()
  }
};

/**
 * Example: Order with only Package items
 */
export const exampleOrderWithPackagesOnly: CreateOrderDto = {
  customerId: '507f1f77bcf86cd799439011',
  items: [
    {
      itemType: OrderItemType.PACKAGE,
      itemId: '507f1f77bcf86cd799439018',
      quantity: 2,
      price: 149.99,
      discountPrice: 119.99,
      packageItems: [
        {
          productId: '507f1f77bcf86cd799439019',
          quantity: 1,
          selectedVariants: [
            { variant: 'color', value: 'red' },
            { variant: 'size', value: 'large' }
          ]
        },
        {
          productId: '507f1f77bcf86cd799439020',
          quantity: 1,
          selectedVariants: [
            { variant: 'color', value: 'blue' },
            { variant: 'size', value: 'medium' }
          ]
        }
      ]
    }
  ],
  totalPrice: 239.98, // 2 * 119.99
  status: OrderStatus.PENDING,
  paymentInfo: {
    paymentStatus: PaymentStatus.PENDING,
    paymentMethod: PaymentMethod.BANK_TRANSFER,
    notes: 'Bank transfer payment - waiting for confirmation'
  }
};